module.exports = __webpack_public_path__ + "static/img/lianxi.f36cb0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lianxi.png
// module id = HSYr
// module chunks = 15